module.exports = __webpack_public_path__ + "static/media/line_post_insulator_stud.c4b725e3.webp";